import React, { useMemo, useRef } from 'react';
import merchantConfig from '../HelperMerchant/merchantConfig.json';
import { ItemCreationSubsection } from '~/Components';
import { useFieldsByGroup } from '../HelperMerchant/useFieldsByGroup';
import { IMerchant, FormField } from '~/Models/DTO/Merchant.models';
import { connect, FormikContextType } from 'formik';
import { useStyles } from '../HelperMerchant/Merchant.style';
import {
  mapFieldsIsRequired,
  checkDependencyByName,
} from '../HelperMerchant/useMerchantValidations';

interface IMerchantFieldFormikWrapper {
  activeStep?: number;
}
interface ICreateMerchantForm {
  activeStep?: number;
}

const MerchantFieldFormikWrapper = connect<IMerchantFieldFormikWrapper, IMerchant>(
  ({
    activeStep = 0,
    formik,
  }: IMerchantFieldFormikWrapper & {
    formik: FormikContextType<IMerchant>;
  }) => {
    const { classes } = useStyles();
    const containerRef = useRef(null);
    const fields = useMemo(
      () =>
        mapFieldsIsRequired(formik.values, merchantConfig?.fields)?.filter(
          ({ name }: FormField) => !checkDependencyByName(name, formik.values),
        ),
      [
        merchantConfig?.fields,
        formik.values?.country,
        formik.values?.entities,
        formik.values?.billable,
        formik.values?.consent,
      ],
    );

    const { getFieldsById, getGroupLabel } = useFieldsByGroup({
      fields,
      groups: merchantConfig?.groups || [],
      values: formik.values,
      setConsent: (event: React.ChangeEvent<HTMLInputElement>) =>
        formik.setFieldValue('consent', event.target.checked),
      isModal: true,
      create: false,
    });

    const selectedGroup = merchantConfig?.groups?.find(({ value }) => value == activeStep);
    const infoSection = getFieldsById(activeStep);
    const label = selectedGroup?.label || '';

    return (
      <div className={classes.sections} key={label} ref={containerRef}>
        {getGroupLabel(activeStep)}
        <div className={classes.sectionContent}>
          <ItemCreationSubsection items={infoSection} noBorder showErrorLabel />
        </div>
      </div>
    );
  },
);

export const useCreateMerchantForm = ({ activeStep = 0 }: ICreateMerchantForm) => {
  const sections = useMemo(() => [() => <MerchantFieldFormikWrapper activeStep={activeStep} />], [
    activeStep,
  ]);
  return { sections };
};
